import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

import OperationForm from './OperationForm';

export default function ConfSetUltraLogConfig(props, context) {
  const [open, setOpen] = React.useState(false);
  const [configValues, setConfigValues] = React.useState(null);

  function askBeforeSubmit(params) {
    setConfigValues(params);
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  function submitValue() {
    handleClose();

    // Map frontend field names to backend field names
    // Backend expects: minimum_purge_size, use_local_time, log_level
    const payload = {
      minimum_purge_size: Number(configValues.minPurgeSize),
      use_local_time: Boolean(configValues.useLocalTime),
      log_level: Number(configValues.loggingLevel)
    };

    props.updateConfig(payload);
  }

  const loggingLevelLabel = (level) => {
    const labels = ['None', 'Error', 'Warn', 'Info', 'Debug'];
    return labels[level] || 'Unknown';
  };

  return (
    <React.Fragment>
      <OperationForm
        enable={props.enable}
        fields={props.fields}
        onSubmit={askBeforeSubmit}
        notify={props.notify}
      />

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='md'
      >
        <DialogContent>
          <DialogContentText style={{fontSize: 'large', color: 'black', textAlign: 'center'}}>
            {context.t('you_are_about_to_take_a_significant_action_on_num_devices', { num: props.countSelected })}<br/>
            <span style={{fontSize: 'medium', color: '#606060'}}>
              {configValues && (
                <>
                  Min Purge Size: {configValues.minPurgeSize}<br/>
                  Use Local Time: {configValues.useLocalTime ? 'Yes' : 'No'}<br/>
                  Logging Level: {loggingLevelLabel(configValues.loggingLevel)}
                </>
              )}
            </span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={handleClose} autoFocus>{context.t('cancel')}</Button>
          <Button color="primary" onClick={submitValue} autoFocus>{context.t('continue')}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

ConfSetUltraLogConfig.propTypes = {
  enable: PropTypes.bool,
  updateConfig: PropTypes.func,
  countSelected: PropTypes.number,
  fields: PropTypes.array,
  notify: PropTypes.func
};

ConfSetUltraLogConfig.contextTypes = {
  t: PropTypes.func.isRequired
};
